<template>
  <w-icon-wrapper icon-name='work-tag-icon'>
    <path
      id='_67_Tag_Icon_Icon'
      d='M23.661.339a1,1,0,0,0-1.412,0l-2.3,2.3L11.608,1.091-.046,12.745l11.3,11.3L22.909,12.392,21.364,4.049l2.3-2.3A1,1,0,0,0,23.661.339ZM20.753,11.722l-9.5,9.5L2.779,12.745l9.5-9.5,5.959,1.1L16.776,5.812a3,3,0,1,0,1.412,1.412L19.65,5.763ZM16.2,7.8a1,1,0,1,1-.706-.293A1,1,0,0,1,16.2,7.8Z'
      data-name='67 Tag Icon_Icon'
      fill='currentColor'
      transform='translate(0.046 -0.046)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconTag' };
</script>
